import axios from 'axios';
import { error as eMessage } from '../assecs/json';

import { resetState } from '../store/pages/loginSlice';
import { setMessage } from '../store/components/alertSlice';
import { showSpinner } from '../store/components/spinnerSlice';
import { baseURL, ORI_API_PATH, V2_API_PATH, PAYMENT_API_PATH } from './urlrouter';

axios.defaults.timeout = 300000;
axios.defaults.baseURL = baseURL;
axios.defaults.headers = { 'Content-Type': 'application/json' };

const Interceptor = (store) => {
    const comparisonTable = {
        '/manage/charging/detail/export': 'invoice_detail',
        '/manage/BatteryMission/vehicleReward/export/csv': 'vehicle_reward',
    };
    const downloadFile = ({ data, headers, config }) => {
        const contentType = headers['content-type'];
        const blob = new Blob([data], { type: contentType });

        // 提取文件名
        const disposition = headers['content-disposition'];
        const urlWithoutTsp = config.url.replace(/\/(?:tsp|v2)(?=\/|$)/, '');
        const defaultFileName = comparisonTable[urlWithoutTsp];
        let fileName = `${ defaultFileName }.xlsx`;
        
        if (!defaultFileName) {
            const sourceData = config.data && JSON.parse(config.data);

            if (!sourceData) {
                if (config.url.includes('/manage/marketing/pushAll/downLoad')) {
                    if (disposition) {
                        const match = disposition.match(/filename="(.+?)"/);
                        if (match && match[1]) {
                            fileName = decodeURIComponent(match[1]);
                        } else {
                            fileName = '清單.xlsx';
                        }
                    } else {
                        fileName = '清單.xlsx';
                    }
                }
            }
            else {
                const startData = sourceData[Object.keys(sourceData).find(key => key.includes('start') || key.includes('Begin'))].replace(/\//g, '');
                const endData = sourceData[Object.keys(sourceData).find(key => key.toLowerCase().includes('end'))].replace(/\//g, '');
                
                if (config.url.includes('/manage/invoice/detail/report')) {
                    fileName = `invoice_${ startData }_${ endData }.xlsx`
                }
                else if (config.url.includes('/manage/invoice/chargingForm/report')) {
                    fileName = `invoice_chargingForm_${ startData }_${ endData }.xlsx`
                }
                else if (config.url.includes('/manage/member/report')) {
                    fileName = `members_${ startData }_${ endData }.xlsx`
                }
            }
        // } else if (disposition) {
        //     const match = disposition.match(/filename="(.+?)"/);
        //     if (match && match[1]) {
        //         fileName = decodeURIComponent(match[1]);
        //     }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };

    axios.interceptors.request.use(
        request => {
            const token = localStorage.getItem('authorization');
            if (token)
                request.headers.Authorization = `Bearer ${token}`;
            
            store.dispatch(showSpinner(true));

            if (request.url.indexOf('VIGP1') > 0) {
                request.baseURL = ORI_API_PATH;
            } else if (request.url.indexOf('threeDomainSecurePayCheck') > 0) {
                request.baseURL = PAYMENT_API_PATH;
            } else if (request.url.indexOf('/v2/') > -1) {
                request.baseURL = V2_API_PATH;
            } else {
                request.baseURL = baseURL;
            }
            
            return request;
        },
        error => {
            console.log('Request', error);
            store.dispatch(showSpinner(false));
        }
    );
    
    axios.interceptors.response.use(
        response => {
            const {data: { result, workShopList, availableDay }} = response;
            const source = result || workShopList || availableDay || response.data;

            setTimeout(() => store.dispatch(showSpinner(false)), 500);

            if (response.config?.responseType === 'blob') {
                const headers = response.headers;
                if (headers['content-type'].includes('application/octet-stream')) {
                    downloadFile(response);
                    return Promise.resolve({ code: '00' });
                }
                return Promise.resolve(response.data);
            }
            
            return Promise.resolve(source);
        },
        error => {
            console.log('Response', error);

            // 💡 修正 1：安全地檢查 error.response 是否存在
            const { response } = error;

            // 如果沒有 response 物件（通常是網路錯誤、逾時），則使用預設值
            // 確保程式碼不會崩潰，並將原始錯誤拋出
            if (!response) {
                // 處理沒有回應時的錯誤訊息提示 (例如：網路連線中斷)
                const _message = { message: error.message || '連線錯誤，請檢查您的網路。' };
                store.dispatch(setMessage(_message));
                store.dispatch(showSpinner(false));
                // 💡 關鍵：將原始錯誤 Promise 拒絕，讓上層的 catch 也能收到，如果需要
                return Promise.reject(error); 
            }

            // 修正 2：如果 response 存在，才安全地解構它
            const { status, data, headers, config } = response;
            const _message = { message: data.errMsg || data.message || eMessage[status] };
            const dispatch = setMessage(_message);
            
            store.dispatch(showSpinner(false));
            
            // if (status !== 404)
                store.dispatch(dispatch);
            
            if (status === 401 || status === 403) {
                setTimeout(() =>  store.dispatch(resetState()), 500);

                if (data?.code !== 'MG401')
                    return data;
            }

            if (data instanceof Blob) {
                // 拒絕 Promise 但不帶錯誤值，以防止上層捕獲到 data 而非 null
                return Promise.reject(null);
            }
            
            if (status === 400 && headers['content-type'].includes('application/octet-stream')) {
                downloadFile(error.response);
            }
            
            // 2025.10.08 新版的API 都有使用 http status，如果非200就是錯誤，要阻止繼續執行
            if (config.url.indexOf('v2') > 0 && status === 500) return Promise.reject(data);

            if (status === 500 && data.code !== '未定義') return data;

            // 💡 關鍵：確保當有回應錯誤時，返回一個被拒絕的 Promise，將 data 傳遞給上層
            return Promise.reject(data);
        }
    )
};

export default Interceptor;